// ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÐºÐ¾Ð½ÐºÑÐµÑÐ½Ð¾Ð³Ð¾ Ð±ÑÐ¾ÐºÐµÑÐ° Ð¿Ð¾Ð²ÐµÑÑ Ð±ÑÐµÐ½Ð´Ð°.
//
// ÐÑÐµÐ½Ð´ (REACT_APP_BRAND) â ÑÑÐ¾ Ð¿Ð°Ð»Ð¸ÑÑÐ° Ð¸ Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿, Ð¸ Horizon Ð¾Ð±ÑÐ¸Ð¹ Ñ Rox Ð¸ JetQ.
// Ð Ð²Ð¾Ñ ÑÑÐ¾ Ð±ÑÐ¾ÐºÐµÑ Ð¿ÑÐ¾Ð´Ð°ÑÑ Ð¸ ÐºÐ°Ðº Ð½Ð°Ð·ÑÐ²Ð°ÐµÑÑÑ â Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ ÑÐ²Ð¾Ñ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð°Ñ
// Ð¿ÐµÑÐµÐ¼ÐµÐ½Ð½Ð°Ñ ÑÐ±Ð¾ÑÐºÐ¸:
//
//   REACT_APP_TENANT=        â ÐºÐ°Ðº Ð±ÑÐ»Ð¾ (DOSCAR, Rox)
//   REACT_APP_TENANT=jetq    â JetQ: ÐÐ£-Ð°Ð²ÑÐ¾ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ
//                              Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ, ÑÐ²Ð¾Ñ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¸ Ð¸ÐºÐ¾Ð½ÐºÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð±ÑÐ°ÑÐ·ÐµÑÐ°
//   REACT_APP_TENANT=mega    â MEGA: ÐºÐ°Ðº JetQ (ÑÐµÑÑÐ¹ Ð´Ð¸Ð»ÐµÑ, ÑÐ¾Ð»ÑÐºÐ¾ ÐÐ£-Ð°Ð²ÑÐ¾ Ð¿Ð¾
//                              Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ), ÑÐ²Ð¾Ñ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð¸ Ð±ÐµÐ· Ð·Ð½Ð°ÑÐºÐ°
import { CAR_ORIGIN_TYPES, CONSIGNMENT_ORIGINS } from '../constants/carOrigin';
import { BANKS } from '../constants';

export const TENANTS = {
  jetq: {
    title: 'JetQ',
    // public/assets â Ð¸ÐºÐ¾Ð½ÐºÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ¸; Ñ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÑ Ð¾ÑÑÐ°ÑÑÑÑ apple-touch-icon.png.
    favicon: '/assets/jetq-icon.png',
    // ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾ JetQ Ð¿ÑÐ¾Ð´Ð°ÑÑ â ÑÐ°Ð·Ð´ÐµÐ»Ñ Ð² Â«ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÑÑÂ» Ð¸ Â«ÐÑÐ¾Ð´Ð°Ð¶Ð°ÑÂ» Ð½Ð° Ð¼ÐµÑÑÐµ,
    // ÐºÐ°Ðº Ñ DOSCAR (Ð²ÐµÑÐ½ÑÐ»Ð¸ 14.10.2026 Ð¿Ð¾ Ð¿ÑÐ¾ÑÑÐ±Ðµ ÐÐ¸Ð¼Ñ).
    // ÐÐ°ÑÐ¸Ð½Ñ Ñ Ð¿ÑÐ¾Ð±ÐµÐ³Ð¾Ð¼ JetQ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ; Ð½Ð° Ð½Ð¾Ð²ÑÐµ
    // ÑÑÐ¾ Ð¾Ð³ÑÐ°Ð½Ð¸ÑÐµÐ½Ð¸Ðµ Ð½Ðµ ÑÐ°ÑÐ¿ÑÐ¾ÑÑÑÐ°Ð½ÑÐµÑÑÑ â ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑÑÑ
    // Ð»Ð¸ÑÑ Ð² ÑÐµÐ¶Ð¸Ð¼Ðµ Â«ÐÐ£ Ð°Ð²ÑÐ¾Â».
    carOrigins: CONSIGNMENT_ORIGINS,
    // Ð¡ÐµÑÑÐ¹ Ð´Ð¸Ð»ÐµÑ ÑÐ¾ÑÐ³ÑÐµÑ Ð»ÑÐ±ÑÐ¼Ð¸ Ð¼Ð°ÑÐºÐ°Ð¼Ð¸: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð·Ð°Ð²Ð¾Ð´Ð¸Ñ Ð¼Ð°ÑÐºÑ, Ð¼Ð¾Ð´ÐµÐ»Ñ Ð¸
    // ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ Ð¿ÑÑÐ¼Ð¾ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð°Ð²ÑÐ¾, Ð½Ðµ Ð´Ð¾Ð¶Ð¸Ð´Ð°ÑÑÑ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÐ°.
    managersAddDictionaries: true,
    // Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ (ÐÐ³ÐµÐ½Ñ â ÐÑÐ¾Ð´Ð°Ð²ÐµÑ â ÐÐ¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ) Ð¿Ð¾ÐºÐ° ÑÐ¾Ð»ÑÐºÐ¾ Ñ DOSCAR.
    // Ð£ JetQ Ð²ÑÐµ Ð¼Ð°ÑÐ¸Ð½Ñ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ â Ð±ÐµÐ· Ð²ÑÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ ÑÐ°Ð³ Ð²ÑÑÐ°Ð» Ð±Ñ Ð² ÐºÐ°Ð¶Ð´ÑÑ ÑÐ´ÐµÐ»ÐºÑ.
    tripartiteContract: false,
    shortForms: true,
  },
  // ÐÐ°ÑÑÐ½ÑÑÑ-ÑÐµÑÑÐµ Ð´Ð¸Ð»ÐµÑÑ Ð·Ð°Ð²Ð¾Ð´ÑÑÑÑ Ð¿Ð¾ Ð¾Ð±ÑÐ°Ð·ÑÑ MEGA: Ð¾ÑÐ»Ð¸ÑÐ°ÐµÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ
  // Ð²ÐºÐ»Ð°Ð´ÐºÐ¸. ÐÐ¾ÐºÐ° Ñ Ð²ÑÐµÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¹ Ð½Ð°Ð±Ð¾Ñ â ÑÐ¾Ð»ÑÐºÐ¾ ÐÐ£-Ð°Ð²ÑÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ,
  // Ð¼Ð°ÑÐºÐ¸ Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð·Ð°Ð²Ð¾Ð´ÑÑ ÑÐ°Ð¼Ð¸. ÐÑÐ»Ð¸ ÐºÑÐ¾-ÑÐ¾ Ð½Ð°ÑÐ½ÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²Ð°ÑÑ Ð½Ð¾Ð²ÑÐµ
  // Ð°Ð²ÑÐ¾, Ñ Ð½ÐµÐ³Ð¾ Ð¿Ð¾ÑÐ²ÑÑÑÑ ÑÐ²Ð¾Ð¸ carOrigins, ÐºÐ°Ðº Ð±ÑÐ»Ð¾ Ñ JetQ.
  evmst: {
    title: 'EV-MASTER',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    shortForms: true,
  },
  bayc: {
    title: 'Bay Cars',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    shortForms: true,
  },
  tswg: {
    title: 'TSW Group',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    shortForms: true,
  },
  drvpt: {
    title: 'Drive Point Auto',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    shortForms: true,
  },
  jsavto: {
    title: 'JS Avto',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    // ÐÐ°ÑÑÐ½ÑÑ ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÑÑÐ¸Ð¼Ð¸ Ð±Ð°Ð½ÐºÐ°Ð¼Ð¸: Ñ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÐ¼Ð¸ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ° Ð½ÐµÑ, Ð¸
    // Ð¾ÑÐ¼ÐµÑÐµÐ½Ð½Ð°Ñ Ð³Ð°Ð»Ð¾ÑÐºÐ° ÑÐ»Ð°Ð»Ð° Ð±Ñ Ð·Ð°ÑÐ²ÐºÑ Ð² Ð½Ð¸ÐºÑÐ´Ð°. ÐÐµÑÐµÐºÐµ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½ 05.11.2026,
    // ÐºÐ¾Ð³Ð´Ð° Ñ Ð±Ð°Ð½ÐºÐ° Ð¿Ð¾ÑÐ²Ð¸Ð»Ð¸ÑÑ ÑÑÐ±Ð¿ÑÐ¾Ð´ÑÐºÑÑ Ð¿Ð¾Ð´ ÐÐ£.
    bankIds: [BANKS.BCK, BANKS.FREEDOM, BANKS.BEREKE, BANKS.SHINHAN],
    shortForms: true,
  },
  // Auto Arena (ÐÐ»Ð¼Ð°ÑÑ) â ÑÐµÐ´ÑÐ¼Ð¾Ð¹ Ð¿Ð°ÑÑÐ½ÑÑ, ÑÐ°Ð·Ð²ÑÑÐ½ÑÑ 28.10.2026 Ð¿Ð¾ Ð¾Ð±ÑÐ°Ð·ÑÑ
  // JS Avto: ÑÐ¾Ð»ÑÐºÐ¾ ÐÐ£-Ð°Ð²ÑÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ Ð¸ ÑÐµ Ð¶Ðµ Ð±Ð°Ð½ÐºÐ¸.
  arena: {
    title: 'Auto Arena',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    bankIds: [BANKS.BCK, BANKS.FREEDOM, BANKS.BEREKE, BANKS.SHINHAN],
    shortForms: true,
  },
  // Empire (ÐÐ»Ð¼Ð°ÑÑ) â Ð²Ð¾ÑÑÐ¼Ð¾Ð¹ Ð¿Ð°ÑÑÐ½ÑÑ, ÑÐ°Ð·Ð²ÑÑÐ½ÑÑ 29.10.2026 Ð¿Ð¾ Ð¾Ð±ÑÐ°Ð·ÑÑ Arena.
  // ÐÐ° ÑÑÐ°ÑÑÐµ Ð±Ð°Ð½Ðº Ð±ÑÐ» Ð¾Ð´Ð¸Ð½ (Ð¨Ð¸Ð½ÑÐ°Ð½): Ñ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÐ¼Ð¸ Ð½Ðµ Ð±ÑÐ»Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°. Ð¡ 03.11.2026
  // ÑÐµ Ð¶Ðµ Ð±Ð°Ð½ÐºÐ¸, ÑÑÐ¾ Ñ Arena, Tulpar Ð¸ JS Avto.
  empire: {
    title: 'Empire',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    bankIds: [BANKS.BCK, BANKS.FREEDOM, BANKS.BEREKE, BANKS.SHINHAN],
    shortForms: true,
  },
  // Tulpar â Ð´ÐµÐ²ÑÑÑÐ¹ Ð¿Ð°ÑÑÐ½ÑÑ, ÑÐ°Ð·Ð²ÑÑÐ½ÑÑ 29.10.2026 Ð¿Ð¾ Ð¾Ð±ÑÐ°Ð·ÑÑ Arena: ÑÐ¾Ð»ÑÐºÐ¾
  // ÐÐ£-Ð°Ð²ÑÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ Ð¸ ÑÐµ Ð¶Ðµ Ð±Ð°Ð½ÐºÐ¸.
  tulpar: {
    title: 'Tulpar',
    favicon: null,
    usedCarsOnly: true,
    // Ð Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐµ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ ÐÐ¦ Ð½Ðµ ÑÑÐ¶Ð°ÐµÐ¼ Ð´Ð¾ ÐÐ¡Ð: DCG Esil Ð·Ð°Ð²ÐµÐ´ÑÐ½ ÑÐ°Ð»Ð¾Ð½Ð¾Ð¼ (used=false)
    // Ð¸ Ð¸Ð½Ð°ÑÐµ Ð½Ðµ Ð²ÑÐ±Ð¸ÑÐ°ÐµÑÑÑ. ÐÑÑÐ°Ð»ÑÐ½ÑÐ¼ Ð±ÑÐ¾ÐºÐµÑÐ°Ð¼ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿Ð¾-Ð¿ÑÐµÐ¶Ð½ÐµÐ¼Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð¸Ð· ÐÐ¡Ð.
    consignmentAnyDc: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    bankIds: [BANKS.BCK, BANKS.FREEDOM, BANKS.BEREKE, BANKS.SHINHAN],
    shortForms: true,
  },
  mega: {
    title: 'MEGA',
    // Ð¡Ð²Ð¾ÐµÐ¹ Ð¸ÐºÐ¾Ð½ÐºÐ¸ Ñ Ð¿Ð°ÑÑÐ½ÑÑÐ° Ð½ÐµÑ, Ð° Ð½Ð°Ñ Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿ Ð½Ð° ÐµÐ³Ð¾ Ð²ÐºÐ»Ð°Ð´ÐºÐµ Ð»Ð¸ÑÐ½Ð¸Ð¹:
    // null â ÑÑÐ¾ Â«ÑÐ±ÑÐ°ÑÑ Ð·Ð½Ð°ÑÐ¾ÐºÂ», Ð° Ð½Ðµ Â«Ð¾ÑÑÐ°Ð²Ð¸ÑÑ ÐºÐ°Ðº ÐµÑÑÑÂ» (ÑÐ¼. applyTenant).
    favicon: null,
    // MEGA â ÑÐµÑÑÐ¹ Ð´Ð¸Ð»ÐµÑ, ÐºÐ°Ðº JetQ: Ð½Ð¾Ð²ÑÑ Ð°Ð²ÑÐ¾ Ð½ÐµÑ, Ð¼Ð°ÑÐ¸Ð½Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ
    // Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ, Ð´Ð¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ Ð½Ðµ Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð½ Ðº Ð¼Ð°ÑÐºÐµ.
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    shortForms: true,
  },
};

export const resolveTenant = (value) => {
  const key = String(value || '').trim().toLowerCase();
  return TENANTS[key] || null;
};

export const tenant = resolveTenant(process.env.REACT_APP_TENANT);

// Ð Ð°Ð·Ð´ÐµÐ»Ñ Â«ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾Â» Ð² Ð¼ÐµÐ½Ñ Â«ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸Â» Ð¸ Â«ÐÑÐ¾Ð´Ð°Ð¶Ð¸Â».
const NEW_CARS_PATHS = ['/cars/new', '/deals/new'];

// Ð Ð°Ð·Ð´ÐµÐ»Ñ Â«ÐÑÐ¾Ð´Ð°Ð¶Â», ÐºÐ¾ÑÐ¾ÑÑÐµ ÐµÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ñ DOSCAR: Halyk Market Ð¿Ð¾Ð´ÐºÐ»ÑÑÑÐ½
// Ðº Ð½ÐµÐ¼Ñ Ð¾Ð´Ð½Ð¾Ð¼Ñ, Ð° Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½Ð¾Ðµ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ, Ð¸Ð· ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ ÐºÐ»Ð¸ÐµÐ½Ñ Ð¿Ð¾Ð´Ð°ÑÑ Ð·Ð°ÑÐ²ÐºÑ
// ÑÐ°Ð¼, â ÑÐ¾Ð¶Ðµ Ð½Ð°ÑÐµ. Ð£ Ð¿Ð°ÑÑÐ½ÑÑÐ¾Ð² (ÑÐµÑÑÑ Ð´Ð¸Ð»ÐµÑÐ¾Ð²) ÑÐ¾ ÑÐ²Ð¾Ð¸Ð¼ tenant Ð¸Ñ Ð½ÐµÑ.
const DOSCAR_ONLY_PATHS = ['/deals/halyk', '/deals/app', '/deals/full-payment'];

// Ð Ð°Ð·Ð´ÐµÐ» Â«ÐÑÐ¾Ð´Ð°Ð¶Â» Ð´Ð»Ñ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ Ñ Ð¿ÐµÑÐ²Ð¸ÑÐ½Ð¾Ð¹ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸ÐµÐ¹ â ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÑÐµÑÑÑ Ð´Ð¸Ð»ÐµÑÐ¾Ð².
export const FIRST_REG_DEALS_PATH = '/deals/first-registration';

/**
 * Â«ÐÐ¾ÑÑÑÐµÐ½Ð¸Ðµ, Ð¿ÐµÑÐ²Ð¸ÑÐ½Ð°Ñ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸ÑÂ» (Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ 7 Ð¸ ÑÐ°Ð·Ð´ÐµÐ» Ð¿ÑÐ¾Ð´Ð°Ð¶) â ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÑÐµÑÑÑ
 * Ð´Ð¸Ð»ÐµÑÐ¾Ð²: Ñ Ð±ÑÐ¾ÐºÐµÑÐ° ÑÐ¾ ÑÐ²Ð¾Ð¸Ð¼ tenant, Ð² ÑÑÑÐ¼ ÑÐ¿Ð¸ÑÐºÐµ carOrigins ÐµÑÑÑ ÑÑÐ¾ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ.
 * Ð£ DOSCAR Ð¸ Rox tenant'Ð° Ð½ÐµÑ, ÑÐ°Ð¼ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ Ð¸ ÑÐ°Ð·Ð´ÐµÐ»Ð° Ð½ÐµÑ.
 */
export const firstRegistrationEnabled = (current = tenant) =>
  current?.carOrigins?.includes(CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG) === true;

/** ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾ Ð±ÑÐ¾ÐºÐµÑÑ: Â«Ð¿ÐµÑÐ²Ð¸ÑÐºÐ°Â» (7) â ÑÐ¾Ð»ÑÐºÐ¾ ÐµÑÐ»Ð¸ Ð¾Ð½Ð° Ð²ÐºÐ»ÑÑÐµÐ½Ð°. */
export const originAvailable = (origin, current = tenant) =>
  origin !== CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG || firstRegistrationEnabled(current);

/**
 * ÐÑÐ½ÐºÑÑ Ð¼ÐµÐ½Ñ Â«ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸Â» Ð¸ Â«ÐÑÐ¾Ð´Ð°Ð¶Ð¸Â»: Ñ Ð±ÑÐ¾ÐºÐµÑÐ° ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÐÐ£-Ð°Ð²ÑÐ¾ Â«ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾Â» ÑÐ±Ð¸ÑÐ°ÐµÐ¼,
 * Ð° ÑÐ°Ð·Ð´ÐµÐ»Ñ Â«Ð¥Ð°Ð»ÑÐºÂ» Ð¸ Â«ÐÐ· Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸ÑÂ» Ð¾ÑÑÐ°Ð²Ð»ÑÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾ Ñ DOSCAR (Ð±ÐµÐ· tenant).
 * Ð Ð°Ð·Ð´ÐµÐ» Â«Ð¿ÐµÑÐ²Ð¸ÑÐºÐ°Â» â Ð½Ð°Ð¾Ð±Ð¾ÑÐ¾Ñ, ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÑÐµÑÑÑ Ð´Ð¸Ð»ÐµÑÐ¾Ð².
 */
export const usedOnlyMenuChildren = (children, current = tenant) => {
  const visible = children.filter((item) => item.path !== FIRST_REG_DEALS_PATH || firstRegistrationEnabled(current));
  return current
    ? visible.filter(
        (item) =>
          !DOSCAR_ONLY_PATHS.includes(item.path) &&
          !(current.usedCarsOnly && NEW_CARS_PATHS.includes(item.path))
      )
    : visible;
};

/**
 * ÐÐ±ÑÑÐµÐ½Ð¸Ðµ Ð½Ð¾Ð²Ð¸ÑÐºÐ° (ÑÑÑ Ñ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ°Ð¼Ð¸ Ð¸ ÑÐµÐº-Ð»Ð¸ÑÑ) â ÑÐ¾Ð»ÑÐºÐ¾ Ñ DOSCAR Ð¸ Rox,
 * Ð³Ð´Ðµ ÑÐ²Ð¾ÐµÐ³Ð¾ tenant Ð½ÐµÑ. Ð¨Ð°Ð³Ð¸ Ð½Ð°Ð¿Ð¸ÑÐ°Ð½Ñ Ð¿Ð¾Ð´ ÑÐ°Ð·Ð´ÐµÐ»Ñ DOSCAR: Ñ Ð±ÑÐ¾ÐºÐµÑÐ¾Ð²
 * Ð¿Ð°ÑÑÐ½ÑÑÐ¾Ð² Ð¿Ð¾Ð»Ð¾Ð²Ð¸Ð½Ñ Ð¸Ð· Ð½Ð¸Ñ Ð½ÐµÑ, Ð¸ ÑÑÑ Ð²Ð¾Ð´Ð¸Ð» Ð±Ñ ÑÐµÐ»Ð¾Ð²ÐµÐºÐ° Ð¿Ð¾ Ð¿ÑÑÑÑÐ¼ Ð¼ÐµÑÑÐ°Ð¼.
 */
export const onboardingEnabled = (current = tenant) => !current;

/**
 * ÐÐ°Ð½ÐºÐ¸, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð±ÑÐ¾ÐºÐµÑ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ Ð² Ð²ÑÐ±Ð¾ÑÐµ. Ð£ Ð±ÑÐ¾ÐºÐµÑÐ° Ð±ÐµÐ· ÑÐ²Ð¾ÐµÐ³Ð¾ ÑÐ¿Ð¸ÑÐºÐ° â Ð²ÑÐµ,
 * ÐºÑÐ¾ Ð¿Ð¾Ð´ÑÐ¾Ð´Ð¸Ñ Ð¿Ð¾ ÑÐ¸Ð¿Ñ Ð¼Ð°ÑÐ¸Ð½Ñ (ÐÐ£-Ð°Ð²ÑÐ¾ Ð¾Ð³ÑÐ°Ð½Ð¸ÑÐµÐ½Ð¾ USED_CAR_BANK_IDS).
 */
export const allowedTenantBankIds = (ids, current = tenant) => {
  if (!Array.isArray(current?.bankIds)) return ids;
  return Array.isArray(ids) ? ids.filter((id) => current.bankIds.includes(id)) : current.bankIds;
};

/** ÐÐ°ÑÐ¸Ð°Ð½ÑÑ Â«ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÑÂ»: Ñ Ð±ÑÐ¾ÐºÐµÑÐ° ÑÐ¾ ÑÐ²Ð¾Ð¸Ð¼ ÑÐ¿Ð¸ÑÐºÐ¾Ð¼ â ÑÐ¾Ð»ÑÐºÐ¾ Ð¾Ð½Ð¸. */
export const allowedOriginOptions = (options, current = tenant) =>
  (current?.carOrigins ? options.filter((option) => current.carOrigins.includes(option.value)) : options).filter(
    (option) => originAvailable(option.value, current)
  );

/** ÐÐ½Ð°ÑÐ¾Ðº DOSCAR â Ð´Ð»Ñ DOSCAR Ð¸ Rox, Ñ ÐºÐ¾ÑÐ¾ÑÑÑ ÑÐ²Ð¾ÐµÐ³Ð¾ tenant Ð½ÐµÑ. */
const DOSCAR_FAVICON = '/assets/apple-touch-icon.png';

/**
 * ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¸ Ð¸ÐºÐ¾Ð½ÐºÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð±ÑÐ°ÑÐ·ÐµÑÐ°.
 *
 * ÐÐ½Ð°ÑÐºÐ° Ð² public/index.html Ð½ÐµÑ: Ð¿Ð¾ÐºÐ° Ð¾Ð½ ÑÐ°Ð¼ ÑÑÐ¾ÑÐ», Ñ Ð¿Ð°ÑÑÐ½ÑÑÐ¾Ð² Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿ DOSCAR
 * ÑÑÐ¿ÐµÐ²Ð°Ð» Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑÑÑ Ð´Ð¾ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÐºÑÐ¸Ð¿ÑÐ° Ð¸ Ð¾ÑÑÐ°Ð²Ð°Ð»ÑÑ Ð²Ð¾ Ð²ÐºÐ»Ð°Ð´ÐºÐµ (22.10.2026,
 * MEGA). ÐÐ¾ÑÑÐ¾Ð¼Ñ ÑÑÐ°Ð²Ð¸Ð¼ ÐµÐ³Ð¾ Ð·Ð´ÐµÑÑ â ÑÐ²Ð¾Ð¸Ð¼, Ð° Ð¿Ð°ÑÑÐ½ÑÑÐ°Ð¼ Ð½Ðµ ÑÑÐ°Ð²Ð¸Ð¼ Ð²Ð¾Ð²ÑÐµ.
 */
export const applyTenant = (doc = document, current = tenant) => {
  if (current?.title) doc.title = current.title;

  // null Ñ Ð¿Ð°ÑÑÐ½ÑÑÐ° â Â«Ð·Ð½Ð°ÑÐºÐ° Ð½ÐµÑÂ», Ñ DOSCAR Ð¸ Rox tenant'Ð° Ð½ÐµÑ Ð²Ð¾Ð²ÑÐµ â Ð·Ð½Ð°ÑÐ¾Ðº ÑÐ²Ð¾Ð¹.
  const favicon = current ? ('favicon' in current ? current.favicon : DOSCAR_FAVICON) : DOSCAR_FAVICON;
  const links = doc.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]');

  if (!favicon) {
    links.forEach((link) => link.remove());
    return;
  }
  if (links.length > 0) {
    links.forEach((link) => link.setAttribute('href', favicon));
    return;
  }
  const link = doc.createElement('link');
  link.setAttribute('rel', 'icon');
  link.setAttribute('href', favicon);
  doc.head.appendChild(link);
};

/** ÐÐ¾Ð¶ÐµÑ Ð»Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð·Ð°Ð²Ð¾Ð´Ð¸ÑÑ Ð¼Ð°ÑÐºÐ¸, Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð¸ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ ÑÐ°Ð¼ (ÑÐµÑÑÐµ Ð´Ð¸Ð»ÐµÑÑ). */
export const managersAddDictionaries = (current = tenant) => current?.managersAddDictionaries === true;

/** ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð² Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐµ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ Ð»ÑÐ±ÑÐµ ÐÐ¦, Ð° Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ ÐÐ¡Ð (used=true). */
export const consignmentAnyDcEnabled = (current = tenant) => current?.consignmentAnyDc === true;

/**
 * ÐÐ¾ÑÐ¾ÑÐºÐ¸Ðµ ÑÐ¾ÑÐ¼Ñ Ð·Ð°ÑÐ²ÐºÐ¸ Ñ ÑÐµÑÐ¾Ð³Ð¾ Ð´Ð¸Ð»ÐµÑÐ° (Ð²ÐºÐ»ÑÑÐµÐ½Ñ Ñ Ð²ÑÐµÑ Ð¿Ð°ÑÑÐ½ÑÑÐ¾Ð², JetQ Ð² ÑÐ¾Ð¼
 * ÑÐ¸ÑÐ»Ðµ; Ñ DOSCAR Ð¸ Rox ÑÐ¾ÑÐ¼Ñ Ð¾ÑÑÐ°ÑÑÑÑ Ð¿Ð¾Ð»Ð½ÑÐ¼Ð¸): Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð½Ðµ ÑÐ¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼ ÑÐµÐ³Ð¸Ð¾Ð½
 * (ÐÐÐ¢Ð), ÑÐ·ÑÐº Ð¸ ÐºÐ¾Ð½ÑÐ°ÐºÑÐ½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ, Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð°Ð²ÑÐ¾ â ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ, Ð¼Ð¾ÑÐ½Ð¾ÑÑÑ Ð¸
 * ÑÐ¸Ð¿ Ð¿ÑÐ¸Ð²Ð¾Ð´Ð°.
 *
 * Ð­ÑÐ¸ Ð¿Ð¾Ð»Ñ Ð½ÑÐ¶Ð½Ñ Ð»Ð¸Ð±Ð¾ Ð±Ð°Ð½ÐºÐ°Ð¼, ÐºÐ¾ÑÐ¾ÑÑÑ Ñ Ð¿Ð°ÑÑÐ½ÑÑÐ° Ð½ÐµÑ (ÐÐÐ¢Ð ÑÑÐ¾Ð´Ð¸Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð² Ð¡Ð°Ð¿Ñ,
 * Solva Ð¸ PledgeCar), Ð»Ð¸Ð±Ð¾ Ð¿Ð¸ÑÑÐ¼Ð°Ð¼ ÐºÐ»Ð¸ÐµÐ½ÑÑ, ÐºÐ¾ÑÐ¾ÑÑÑ Ð¿Ð°ÑÑÐ½ÑÑ Ð½Ðµ ÑÐ»ÑÑ. ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ
 * Ð±ÐµÐ· Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð»ÑÐµÐ¼ ÑÐ°Ð¼Ð¸: Ð±ÐµÐ· Ð½ÐµÑ Ð°Ð²ÑÐ¾ Ð½Ðµ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð² ÑÐ´ÐµÐ»ÐºÑ.
 */
export const shortFormsEnabled = (current = tenant) => current?.shortForms === true;

/** ÐÑÐ¶ÐµÐ½ Ð»Ð¸ ÑÐ°Ð³ Â«Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÂ» Ð² ÑÐ´ÐµÐ»ÐºÐ°Ñ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ. */
export const tripartiteContractEnabled = (current = tenant) => current?.tripartiteContract !== false;
